import { UserRole } from "../types/enums";

export const isUserRole = (value: unknown): value is UserRole => {
  return typeof value === "string" && Object.values(UserRole).includes(value as UserRole);
};
